import PropTypes from 'prop-types';

const VideoBlock = ({ vimeoId, title, videoDescription, altText }) => {
	return (
		<div className="video-block">
			<div className="video-block__content">
				<div className="video-block__copy">
					<h2 className="typography typography--h2 typography--secondary">
						{title}
					</h2>
					<p className="typography typography--subtle-big typography--secondary">
						{videoDescription}
					</p>
				</div>
				<div className="video-container">
					<iframe
						title={altText}
						className="video-container__iframe"
						src={`https://player.vimeo.com/video/${vimeoId}?title=0&byline=0&portrait=0`}
						frameBorder="0"
						allow="autoplay; fullscreen; picture-in-picture"
						allowFullScreen
					/>
				</div>
			</div>
		</div>
	);
};

VideoBlock.propTypes = {
	vimeoId: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	videoDescription: PropTypes.string.isRequired,
	altText: PropTypes.string.isRequired,
};

export default VideoBlock;
